import { homeStateSelector } from "@store/redux/modules/home";
import { useSelector } from "react-redux";
import { pxChangeVw } from "@/utils";
import { useTranslation } from "react-i18next";
const ChartData: React.FC<any> = ({ aqi = undefined }: any) => {
  aqi = (aqi || useSelector(homeStateSelector)?.["aqi"]) ?? {};
  const { t: $t } = useTranslation();
  return (
    <>
      <WeatherMainContent className="content w-full flex justify-between items-center">
        <div className="inline-block w-40% m-[0_auto]">
          <div className="w-full h-full p-10 relative flex flex-col items-center gap-y-4">
            <div
              className="w-100 h-100 rounded-50% relative z-5"
              style={{
                background: "conic-gradient(rgb(255, 204, 0) 10%, rgba(255, 255, 255, 0.3) 0%)",
                mask: "radial-gradient(transparent 2.5rem, #000 2.5rem)",
              }}
            ></div>
            <div className="flex flex-col items-center gap-y-8">
              <div className="absolute text-center w-100 h-100 flex flex-col justify-center rounded-50% top-10">
                <h1 style={{ fontSize: pxChangeVw("18px") }}>{aqi?.Value}</h1>
                <p style={{ fontSize: pxChangeVw("12px"), color: "rgba(255,255,255,0.66)" }}>{$t("title04")}</p>
              </div>
              <p style={{ color: "#ffcc00", textAlign: "center" }}>{aqi?.Category}</p>
            </div>
          </div>
        </div>
      </WeatherMainContent>
    </>
  );
};
export default ChartData;
